// Reusing the resource listing page
import ResourceListingPage from "~/pages/resource/index";

export default ResourceListingPage;
